import React from 'react';
import { Link } from 'react-router-dom';
export const Hero = () => {
  return <div className="relative bg-rose-900" data-id="element-122">
      <div className="absolute inset-0 overflow-hidden" data-id="element-123">
        <img src="https://images.unsplash.com/photo-1581578731548-c64695cc6952?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80" alt="Appliance repair engineer" className="w-full h-full object-cover opacity-30" data-id="element-124" />
        <div className="absolute inset-0 bg-gradient-to-r from-rose-900 via-rose-900/90 to-transparent" data-id="element-125"></div>
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32" data-id="element-126">
        <div className="max-w-3xl" data-id="element-127">
          <h1 className="text-4xl md:text-5xl font-extrabold text-white tracking-tight" data-id="element-128">
            Fast, Reliable Appliance Repairs Across the UK
          </h1>
          <p className="mt-6 text-xl text-rose-100 max-w-3xl" data-id="element-129">
            Professional service when you need it most. Our expert engineers
            deliver fixed-price repairs with guaranteed results.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-130">
            <Link to="/service-coverage" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-rose-900 bg-white hover:bg-rose-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-white" data-id="element-131">
              Our Services
            </Link>
            <Link to="/contact" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-amber-500 hover:bg-amber-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-amber-500" data-id="element-132">
              Contact Us
            </Link>
          </div>
        </div>
      </div>
    </div>;
};